import api from '../../plugins/api';

const createContainer = (params) => {
  return api.uploadFile('/api/crm/cars/createContainer', params);
};

export default createContainer;
